/*
 * Function checks isSmbFlagged = IS_FLAGGED/IS_NOT_FLAGGED in the sessionStorage
 * if not available
 * fetches isFlagged value from API and sets in the sessionStorage
 */

export const SMB_FLAG_SESSION_STORAGE_KEY = 'isSmbFlagged';
export const SMB_FLAG_TRUE = 'IS_FLAGGED';
export const SMB_FLAG_FALSE = 'IS_NOT_FLAGGED';

export const isSmbFlaggedFromSessionStorageCache = async (fn: Function, ...params: any[]) => {
  const currentStorageValue = sessionStorage.getItem(SMB_FLAG_SESSION_STORAGE_KEY);
  if (currentStorageValue === SMB_FLAG_TRUE || currentStorageValue === SMB_FLAG_FALSE) {
    return currentStorageValue === SMB_FLAG_TRUE;
  }
  try {
    const response = await fn.apply(null, [...params]);
    const smbFlag = response.isFlagged ? SMB_FLAG_TRUE : SMB_FLAG_FALSE;
    sessionStorage.setItem(SMB_FLAG_SESSION_STORAGE_KEY, smbFlag);
    return smbFlag === SMB_FLAG_TRUE;
  } catch {
    return false;
  }
};

/**
 * Generic function for getting value from sessionStorage or API
 * @param {string} sessionStorageKey
 * @param {function} fn
 * @param  {...any} params
 */

async function fromSessionStorageCache(sessionStorageKey: string, fn: Function, ...params: any[]) {
  let sessionStorageValue = sessionStorage.getItem(sessionStorageKey);
  if (sessionStorageValue !== null) {
    try {
      return JSON.parse(sessionStorageValue);
    } catch {
      return sessionStorageValue;
    }
  }

  try {
    const response = await fn.apply(null, [...params]);

    sessionStorageValue = response;
    sessionStorageValue = JSON.stringify(sessionStorageValue);
    sessionStorage.setItem(sessionStorageKey, sessionStorageValue);

    return response;
  } catch {
    return undefined;
  }
}

export default fromSessionStorageCache;
